package com.pincer.core.model

import com.pincer.core.InvalidData
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json
import kotlinx.serialization.SerializationException
import kotlin.js.JsName

/*
Any device interacting with the system.
An installation of a an application on a smart phone would be a device.
A browser context (individual session, or sessions linked by local storage) is a device.
We also model the server side agents as devices for logging purposes.

When you register a new device, you are also set up with a credless principal, but it is
possible to have a device without a principal. This is the case after a logout.
*/

@Serializable
data class Device

(

    @JsName("id")                val id: String,
    @JsName("secret")            val secret: String,
    @JsName("principalId")       val principalId: String? = null,

)

{

    companion object {
        fun parse(json: String): Device {
            try { return Json.decodeFromString<Device>(serializer(), json) }
            catch (jde: SerializationException) { throw InvalidData("There's a problem with the Device json: $json") }
        }
    }

    fun json(): String {
        return Json.encodeToString(serializer(), this)
    }

    fun secretHidden(): String = secret.substring(0,14) + "********"

}
